RivalIQ.apps.Dashboard.module('mixins', function (mixins, App, Backbone, Marionette, $, _) {

    'use strict';

    function getExportView() {
        const layout = this;

        let View;
        const format = layout.getProp('format');

        switch (format) {
            case RivalIQ.enums.exportFormat.PDF:
                View = layout.pdfPanel;
                break;
            case RivalIQ.enums.exportFormat.PPT:
                View = layout.pptPanel;
                break;
            case RivalIQ.enums.exportFormat.PNG:
                View = layout.pngPanel;
                break;
            // This default case comes up when you've got a scheduled CSV export; in that case, we load
            // this curation with format = csv. The view we use ultimately doesn't matter, so fallback
            // to the default export widgets view.
            default:
                return App.views.ExportWidgets;
        }

        return App.views.ExportWidgets.extend({
            onBeforeRenderLoaded: function () {
                const me = this;

                // don't show the titlebar for ppt as that info will be displayed in a title page.
                if (!me.dashboardModel.isExportingPPT()) {
                    me.header.show(new App.views.TitleBar({
                        dashboardModel: me.dashboardModel
                    }));
                }

                const widget = me.dashboardModel.getWidgets().first();

                me.widgets.show(new View({
                    dashboardModel: widget
                }));
            }
        });
    }

    mixins.SingleWidget = {
        isFocus: _.constant(true),

        getBasePath: function (props) {
            const me = this;
            return me.router.resolveCurationRoute(me.id, _.omit(props, 'instanceId'));
        },

        getBaseUrlObject: function (props) {
            const me = this;
            return me.router.resolveCurationRouteObject(me.id, _.omit(props, 'instanceId'));
        },

        getExportTitle: function () {
            const me = this;
            return me.getWidgets().first().getExportTitle();
        },

        getExportSubtitle: function () {
            const me = this;
            return me.getWidgets().first().getExportSubtitle();
        },

        widgetShouldIncludeTitleSlide: _.constant(true),

        buildScheduledReport: function (attrs) {
            // let the single widget do the export so scheduled export
            // matches the manual export behavior for single widget views
            const me = this;
            const widget = me.getWidgets().first();
            return widget.buildScheduledReport(attrs);
        },

        pdfPanel: App.views.NoHeadingPdfPanel,
        pptPanel: App.views.PptPanel,
        pngPanel: App.views.NoHeadingPngPanel,

        // special view that doesn't show the title and subtitle from the widget.
        exportWidgetsView: getExportView,
        // NOTE override inherited curation layouts
        pdfWidgetsView: getExportView,
        pngWidgetsView: getExportView,
        pptWidgetsView: getExportView
    };
});
